// extracted by mini-css-extract-plugin
export default {"container":"d1-z","list":"e1-z"};